import { fetchHandler, fetchHandlerForm } from "../Handler/Handler";


export const POSTVendorsubcategory = async (slugname, data) => {
    try {
        const response = await fetchHandler({
            method: "POST",

            endpoint: `/subcategory/vendor/${slugname}/newsubcategory`,
            data,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const UpdatesubcategoryVendor = async (slugname, data, id) => {
    try {
        const response = await fetchHandler({
            method: "PUT",
            endpoint: `/subcategory/vendor/${slugname}/updatesubcategory/${id}`,
            data: data,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const UpdatestatusVendorsubcategory = async (slugname, data, id) => {
    try {

        const response = await fetchHandler({
            method: "PATCH",
            endpoint: `/subcategory/vendor/${slugname}/status/${id}`,
            data: data,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const GetVendorsubcategory = async (slugname) => {
    try {

        const response = await fetchHandler({
            method: "GET",
            endpoint: `/subcategory/vendor/${slugname}/subcategories`,
            data: null
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const GETVendorsubcategory = async (slugname) => {
    try {
        const response = await fetchHandler({
            method: "GET",
            endpoint: `/subcategory/${slugname}/products/`,
            data: null,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const DELETEsubcategory = async (slugname, id) => {
    try {
        const response = await fetchHandler({
            method: "DELETE",
            endpoint: `/subcategory/vendor/${slugname}/deletesubcategory/${id}`,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};


export const GETSinglesubcategory = async (slugname, id,) => {
    try {

        const response = await fetchHandler({
            method: "GET",
            endpoint: `/subcategory/vendor/${slugname}/subcategories/${id}`,
            data: null,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};

export const GETSinglecat = async (slugname, id) => {
    try {

        const response = await fetchHandler({
            method: "GET",
            endpoint: `/category/vendor/${slugname}/subcategories/${id}`,
            data: null,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
}
export const GETSingleProductby = async (slugname, id) => {
    try {



        const response = await fetchHandler({
            method: "GET",
            endpoint: `/vendor/${slugname}/product/getprodutbysubcategory/${id}`,
            data: null,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};


export const GETSingleCategory = async (id) => {
  try {
    const response = await fetchHandler({
      method: "GET",
      endpoint: `/category/admin/${id}`,
      data: null,
    });

    return response;
  } catch (error) {
    console.error("Unexpected error:", error);
  }
};